import def_0 from "./attribute_sets";
import def_1 from "./attributes";
import def_2 from "./bim";
import def_3 from "./color_pairing";
import def_4 from "./document_builder";
import def_5 from "./documents";
import def_6 from "./fleetwood_blog";
import def_7 from "./forms";
import def_8 from "./helpers/ArticleItemList";
import def_9 from "./helpers/BimProductGroupModal";
import def_10 from "./helpers/GenericContentSearch";
import def_11 from "./helpers/PfcItem";
import def_12 from "./helpers/ProductItem";
import def_13 from "./helpers/ProductItemList";
import def_14 from "./helpers/Shingle";
import def_15 from "./helpers/ShingleList";
import def_16 from "./helpers/SwoogoEvents";
import def_17 from "./helpers/handle_external_url";
import def_18 from "./helpers/item_list_response";
import def_19 from "./helpers/path_to_content";
import def_20 from "./helpers/query_legacy_products";
import def_21 from "./helpers/retrieveImage";
import def_22 from "./insulation_applications_blog";
import def_23 from "./insulation_industrial_blog";
import def_24 from "./insulation_residential_blog";
import def_25 from "./iss";
import def_26 from "./lumber_blog";
import def_27 from "./newsroom_blog";
import def_28 from "./paroc_articles";
import def_29 from "./products_enclosure";
import def_30 from "./products_fleetwood";
import def_31 from "./products_insulation";
import def_32 from "./products_paroc";
import def_33 from "./products_pfc";
import def_34 from "./products_roofing";
import def_35 from "./reusable";
import def_36 from "./roofing_blog";
import def_37 from "./shingles";
import def_38 from "./swoogo_events";



export default {
  "attribute_sets": def_0,
  "attributes": def_1,
  "bim": def_2,
  "color_pairing": def_3,
  "document_builder": def_4,
  "documents": def_5,
  "fleetwood_blog": def_6,
  "forms": def_7,
  "helpers": {
    "ArticleItemList": def_8,
    "BimProductGroupModal": def_9,
    "GenericContentSearch": def_10,
    "PfcItem": def_11,
    "ProductItem": def_12,
    "ProductItemList": def_13,
    "Shingle": def_14,
    "ShingleList": def_15,
    "SwoogoEvents": def_16,
    "handle_external_url": def_17,
    "item_list_response": def_18,
    "path_to_content": def_19,
    "query_legacy_products": def_20,
    "retrieveImage": def_21
  },
  "insulation_applications_blog": def_22,
  "insulation_industrial_blog": def_23,
  "insulation_residential_blog": def_24,
  "iss": def_25,
  "lumber_blog": def_26,
  "newsroom_blog": def_27,
  "paroc_articles": def_28,
  "products_enclosure": def_29,
  "products_fleetwood": def_30,
  "products_insulation": def_31,
  "products_paroc": def_32,
  "products_pfc": def_33,
  "products_roofing": def_34,
  "reusable": def_35,
  "roofing_blog": def_36,
  "shingles": def_37,
  "swoogo_events": def_38
};